module.exports = __webpack_public_path__ + "img/partner-tecnologic-lomusic.95b427c5.png";